import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Fragment, useState, useEffect } from 'react';
import { Disclosure, Menu, Transition } from '@headlessui/react';
import { Bars3Icon, XMarkIcon, UserCircleIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import config from '../../config';
import { localData } from '../../functions';

const navigation = [
    { name: 'Waiting Room', href: '/waiting-room', current: false, role_id: '' },
    { name: 'Users', href: '/users', current: false, role_id: 1 },
]

const userNavigation = [
    { name: 'Profile', href: '/profile', icon: <UserCircleIcon className="h-4 w-4 mr-2" /> },
    { name: 'Logout', href: '/logout', icon: <ArrowRightOnRectangleIcon className="h-4 w-4 mr-2" /> },
]

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

function Header() {
    const [isSticky, setIsSticky] = useState(false);
    const userInfo = localData('user');
    const location = useLocation();

    const handleScroll = () => {
        const offset = window.scrollY;
        if (offset > 10) {
            setIsSticky(true);
        } else {
            setIsSticky(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const updatedNavigation = navigation.map(item => ({
        ...item,
        current: location.pathname === item.href
    }));

    return (
        <>
            <Disclosure as="header" className={`bg-white dark:bg-slate-800 shadow ${isSticky ? 'fixed top-0 z-40 w-full' : ''}`}>
                {({ open }) => (
                    <>
                        <div className="mx-auto max-w-8xl px-2 sm:px-4 lg:divide-y lg:divide-gray-200 lg:px-8">
                            <div className="flex h-16 justify-between">
                                <div className="flex">
                                    <div className="flex flex-shrink-0 items-center">
                                        <Link to="/waiting-room">
                                            <img className="mx-auto h-10 w-auto" src={`${config.appUrl}/logo.svg`} alt="DocPro"></img>
                                        </Link>
                                    </div>
                                    <div className="hidden sm:ml-6 lg:ml-12 sm:flex sm:space-x-8">
                                        {updatedNavigation.map((item) => (
                                            item.role_id === '' || item.role_id === userInfo?.role_id ?
                                                <Link
                                                    key={item.name}
                                                    to={item.href}
                                                    className={classNames(
                                                        item.current ? 'border-indigo-500 dark:border-gray-300 text-gray-900 dark:text-gray-300' : 'border-transparent text-gray-500 dark:text-gray-400 hover:border-gray-300 dark:hover:border-gray-500 hover:text-gray-700 dark:hover:text-gray-300',
                                                        'inline-flex items-center border-b-2 px-2 pt-1 text-md font-medium'
                                                    )}
                                                >
                                                    {item.name}
                                                </Link>
                                            :
                                            ''
                                        ))}
                                    </div>
                                </div>
                                <div className="relative z-10 flex items-center lg:hidden">
                                    <Disclosure.Button className="relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                                        <span className="absolute -inset-0.5" />
                                        <span className="sr-only">Open menu</span>
                                        {open ? (
                                            <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                                        ) : (
                                            <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                                        )}
                                    </Disclosure.Button>
                                </div>

                                <div className="hidden lg:relative lg:z-10 lg:ml-4 lg:flex lg:items-center">

                                    <Menu as="div" className="relative ml-4 flex-shrink-0">
                                        <div>
                                            <Menu.Button className="relative flex rounded-full bg-white dark:bg-slate-600 dark:pr-1 dark:py-0.5 focus:outline-none focus:ring-2 dark:focus:ring-0 focus:ring-indigo-500 dark:focus:ring-white-500 focus:ring-offset-2">
                                                <span className="absolute -inset-1.5" />
                                                <span className="sr-only">Open user menu</span>
                                                <div className="flex-shrink-0">
                                                    <img className="h-10 w-10 rounded-full" src={config.appUrl+'/images/user/user.jpg'} alt="User" />
                                                </div>
                                                <div className="ml-3 pr-1">
                                                    <div className="text-left text-sm font-medium text-gray-800 dark:text-gray-300">{userInfo ? userInfo.name : 'Practice'}</div>
                                                    <div className="text-left text-xs font-normal text-gray-500 dark:text-gray-400">{userInfo ? userInfo.role_name : ''}</div>
                                                </div>
                                            </Menu.Button>
                                        </div>
                                        <Transition
                                            as={Fragment}
                                            enter="transition ease-out duration-100"
                                            enterFrom="transform opacity-0 scale-95"
                                            enterTo="transform opacity-100 scale-100"
                                            leave="transition ease-in duration-75"
                                            leaveFrom="transform opacity-100 scale-100"
                                            leaveTo="transform opacity-0 scale-95"
                                        >
                                            <Menu.Items className="absolute right-0 z-50 mt-2 w-48 origin-top-right rounded-md bg-white dark:bg-slate-600 py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                                                {userNavigation.map((item) => (
                                                    <Menu.Item key={item.name}>
                                                        {({ active }) => (
                                                            <Link to={item.href}
                                                                className={classNames(
                                                                    active ? 'bg-gray-100 dark:bg-gray-500' : '',
                                                                    'block px-4 py-2 text-sm text-gray-700 dark:text-gray-300'
                                                                )}
                                                            >
                                                                <span className='flex items-center'>
                                                                    {item.icon}
                                                                    {item.name}
                                                                </span>
                                                            </Link>
                                                        )}
                                                    </Menu.Item>
                                                ))}
                                            </Menu.Items>
                                        </Transition>
                                    </Menu>
                                </div>
                            </div>
                        </div>
         
                        <Disclosure.Panel className="sm:hidden max-h-screen overflow-y-scroll" aria-label="Global">
                            <div className="space-y-1 pb-3 pt-2">
                                {updatedNavigation.map((item) => (
                                    <Link
                                        key={item.name}
                                        to={item.href}
                                        className={classNames(
                                            item.current ? 'bg-indigo-50 border-indigo-500 text-indigo-700' : 'border-transparent text-gray-500 dark:text-gray-400 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700',
                                            'block border-l-4 py-2 pl-3 pr-4 text-base font-medium'
                                        )}
                                    >
                                        {item.name}
                                    </Link>
                                ))}
                            </div>
                            <div className="border-t border-gray-200 pb-3 pt-4">
                                <div className="flex items-center px-4">
                                    <div className="flex-shrink-0">
                                        <img className="h-10 w-10 rounded-full" src={config.appUrl+'/images/user/user.jpg'} alt="User" />
                                    </div>
                                    <div className="ml-3">
                                        <div className="text-base font-medium text-gray-800 dark:text-gray-300">{userInfo ? userInfo.name : 'Practice'}</div>
                                        <div className="text-sm font-medium text-gray-500 dark:text-gray-400">{userInfo ? userInfo.role_name : ''}</div>
                                    </div>
                                    <div className='ml-auto flex-shrink-0 flex items-center'>

                                    </div>
                                </div>

                                <div className="mt-3 space-y-1 px-2 pb-20">
                                    {userNavigation.map((item) => (
                                        <Link
                                            key={item.name}
                                            to={item.href}
                                            className="block rounded-md px-3 py-1 text-base font-medium text-gray-500 dark:text-gray-400 hover:bg-gray-50 hover:text-gray-900"
                                        >
                                            {item.name}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </Disclosure.Panel>

                    </>
                )}
            </Disclosure>

        </>
    );
}

export default Header;
